import * as React from "react";
import { SVGProps } from "react";
const Notification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2439_2411)">
      <path
        d="M5 21.7145V20.4287H17.8571V21.7145C17.8571 23.0002 18.5 24.2859 20.4286 24.2859H7.57143C5.64286 24.2859 5 23.0002 5 21.7145Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57129 20.4286V3.71436H22.9999V21.7144C22.9999 23.0057 22.357 24.2858 20.4284 24.2858H17.857"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4287 7.57153H19.143"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4287 11.4285H19.143"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4287 15.2856H19.143"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x={18} width={10} height={10} rx={5} fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2439_2411">
        <rect width={28} height={28} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Notification;
